import {t} from 'i18next';
import PropTypes, { element } from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseListContainer from '../../baseContainers/BaseListContainer';
import CriteriaTextComponent from '../../components/criteria/CriteriaTextComponent';
import AppPrefixUtils from '../../utils/AppPrefixUtils';
import I18nUtils from '../../utils/I18nUtils';
import UserTransportService from '../../services/UserTransportService';
import Constants from '../../utils/constants';
import ActionLink from '../../components/ActionLink';
import StringUtils from '../../utils/StringUtils';
import ActionButton from '../../components/ActionButton';
import YesNoDialog from '../../components/YesNoDialog';
import InternalUserService from '../../services/MobileUserService';
import CriteriaMultiSelectComponent from '../../components/criteria/CriteriaMultiSelectComponent';
import {Tooltip} from 'primereact/tooltip';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';
import CriteriaCheckboxComponent from '../../components/criteria/CriteriaCheckboxComponent';
import CriteriaCalendarRangeComponent from '../../components/criteria/CriteriaCalendarRangeComponent';
import CriteriaInputNumberComponent from '../../components/criteria/CriteriaInputNumberComponent';
import { Button, Menu, Slider } from 'primereact';
import CriteriaSliderComponent from '../../components/criteria/CriteriaSliderComponent';
import CriteriaDropdownComponent from '../../components/criteria/CriteriaDropdownComponent';
import InputDropdownComponent from '../../components/inputs/InputDropdownComponent';
import TransportService from '../../services/TransportService';
import CompanyTransportService from '../../services/CompanyTransportService';
import moment from 'moment';

class UserTransportListContainer extends BaseListContainer {
    constructor(props) {
        super(props, new UserTransportService());
        this.state = {
            list: [],
            loading: false,
            size: 0,
            renderDialog: false,
            first: 0,
            criteria: this.getCleanSearchCriteria(),
            filters: {},
            showConfirmExcludeTransport: false,
            showConfirmIncludeTransport: false,
            showConfirmDeleteTransport: false,
            elementId: null,
            element: {
                includeDirection: null,
            },
            directionOptions: [
                {
                    id: 1,
                    value: 'FROM_WORK',
                    label: t('DirectionType.FROM_WORK'),
                },
                {
                    id: 2,
                    value: 'TO_WORK',
                    label: t('DirectionType.TO_WORK'),
                },
                {
                    id: 3,
                    value: 'UNSET',
                    label: t('DirectionType.UNSET'),
                },
            ],
            travelCreditedOptions: [
                {
                    enumValue: false,
                    label: t('global.no'),
                },
                {
                    enumValue: true,
                    label: t('global.yes'),
                },
            ],
            transportOptions: []
        };
        this.mobileUserService = new InternalUserService();
        this.companyTransportService = new CompanyTransportService();
    }

    updateSearchCriteria(criteria) {
        return {
            locale: criteria.locale,
            headers: criteria.headers,
            transport: criteria.transport,
            direction: criteria.direction,
            percentageDeviation: criteria.percentageDeviation,
            startTravelDate: criteria.startTravelDate,
            finishTravelDate: criteria.finishTravelDate,
            directions: criteria.directions,
            userName: criteria.userName,
            userRequestedInclude: criteria.userRequestedInclude,
            firstResult: criteria.firstResult,
            maxResults: criteria.maxResults,
            sortField: criteria.sortField,
            sortAsc: criteria.sortAsc,
            travelCredited: criteria.travelCredited
        };
    }

    getCleanSearchCriteria() {
        return {
            locale: this.authService.getI18n(),
            transport: null,
            direction: undefined,
            directions: [],
            userName: '',
            percentageDeviation: [-100,100],
            startTravelDate: '',
            finishTravelDate: '',
            userRequestedInclude: false,
            firstResult: 0,
            maxResults: 10,
            sortField: 'startTravelDate',
            sortAsc: false,
            travelCredited: undefined
        };
    }
    tableHeader() {
        return (
            <div className='flex flex-wrap justify-content-end gap-2'>
                <ActionButton
                    label={t('user-transport.add')}
                    iconName={'mdi-plus'}
                    iconSide='left'
                    id='addTransport'
                    handleClick={() => {
                        // window.location.href = AppPrefixUtils.locationHrefUrl(this.props.newUrl + '/pl');
                        this.props.history.push(AppPrefixUtils.locationHrefUrl(this.props.newUrl + '/pl'));
                    }}
                />
                <ActionButton
                    reverse
                    label={t('user-transport.export')}
                    handleClick={() => {
                        this.service.export(this.state.criteria, t('user-transport.listName'), 'xlsx').catch((ex) => {
                            this.showErrorMessage(t('user-transport.export-error'));
                        });
                    }}
                />
            </div>
        );
    }

    initializeFromBackend() {
        this.companyTransportService
            .getTransportDictTypes()
            .then((transportOptions) => {
                this.setState({
                    transportOptions: transportOptions.transportTypes,
                });
            })
            .catch((err) => {
                this.showErrorMessage(err.message);
            });
    }

    getDataKey() {
        return 'id';
    }
    getListTitle() {
        return 'user-transport.listTitle';
    }
    getCriteriaName() {
        return 'user-transport-list-sc';
    }

    getContainerListName() {
        return 'user-transport-list-container';
    }
    renderCriteria() {
        
        return (
            <div>
                <div className='row'>
                    <CriteriaDropdownComponent
                        id='transport-sc'
                        name='transport'
                        label={t('user-transport.name')}
                        placeholder={t('global.choose')}
                        colClass='col-xl-3 col-lg-4 col-md-6 col-sm-12'
                        options={this.state.transportOptions}
                        value={this.state.criteria.transport}
                        optionLabel='name'
                        dataKey='transportId'
                        showClear
                        onChange={this.handleChangeSc}
                        validator={this.validator}
                    />
                    <CriteriaTextComponent
                        id='userName-sc'
                        name='userName'
                        label={t('user-transport.user')}
                        colClass='col-xl-3 col-lg-4 col-md-6 col-sm-12'
                        value={this.state.criteria.userName}
                        onChange={this.handleChangeSc}
                        validator={this.validator}
                    />
                    <CriteriaMultiSelectComponent
                        id='directionType-sc'
                        name='directions'
                        label={t('user-transport.direction')}
                        colClass='col-xl-3 col-lg-4 col-md-6 col-sm-12'
                        onChange={this.handleChangeSc}
                        options={this.state.directionOptions}
                        optionLabel='label'
                        showClear
                        placeholder={t('global.all')}
                        value={this.state.criteria.directions}
                        dataKey='id'
                        timeoutHandler={this.refreshTable}
                    />

                   <CriteriaDropdownComponent
                        id='travelCredited-sc'
                        name='travelCredited'
                        label={t('user-transport.included')}
                        placeholder={t('global.choose')}
                        colClass='col-xl-3 col-lg-4 col-md-6 col-sm-12'
                        options={this.state.travelCreditedOptions}
                        value={this.state.criteria.travelCredited}
                        onChange={this.handleChangeSc}
                        validator={this.validator}
                    />


                    <CriteriaCalendarRangeComponent
                        id='date-sc'
                        idFrom='startTravelDate-sc'
                        idTo='finishTravelDate-sc'
                        label={t('')}
                        labelFrom={t('user-transport.startDate')}
                        labelTo={t('user-transport.endDate')}
                        name='createDate'
                        nameFrom='startTravelDate'
                        nameTo='finishTravelDate'
                        colClass='col-xl-6 col-lg-8 col-md-12 col-sm-12'
                        from={this.state.criteria.startTravelDate}
                        to={this.state.criteria.finishTravelDate}
                        onChange={this.handleChangeSc}
                        validator={this.validator}
                        showButtonBar
                        sharedLabel={false}
                        maxDateInfinite
                        placeholderFrom={''}
                        placeholderTo={''}
                        inputsClassName='col-md-6 col-sm-12'
                        refreshFromBackend
                        
                    />
                    <CriteriaSliderComponent
                        id='percentageDeviation-sc'
                        name='percentageDeviation'
                        label={t('user-transport.deviation')}
                        colClass='col-xl-3 col-lg-6 col-md-6 col-sm-12'
                        value={this.state.criteria.percentageDeviation}
                        min={-100}
                        max={100}
                        step={10}
                        onChange={this.handleChangeSc}
                    />
                    <CriteriaCheckboxComponent
                        id='userRequestedInclude'
                        name='userRequestedInclude'
                        colClass='col-xl-3 col-lg-6 col-md-6 col-sm-12'
                        label={t('user-transport.request')}
                        value={this.state.criteria.userRequestedInclude}
                        onChange={this.handleChangeSc}
                        validator={this.validator}
                    />
                </div>
            </div>
        );
    }

    prepareHeaderItems() {
        return [];
    }
    avatarTemplate = (rowData) => {
        const fileUuid = rowData?.user?.avatar?.fileUuid;
        const avatarPath = this.mobileUserService.getPath() + `/${fileUuid}/avatar/current-user`;
        const img = StringUtils.isBlank(fileUuid) ? (
            ''
        ) : (
            <img
                src={`${avatarPath}?token=${this.authService.getToken()}`}
                alt='Avatar'
                // src={`https://source.unsplash.com/random/800x600`}
                className='product-image'
                style={{borderRadius: '50%', height: '30px', width: '30px', marginBottom: '-10px', marginTop: '-10px'}}
            />
        );
        return img;
    };

    prepareColumns() {
        const singleLineEllipsisStyle = {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        };
        const fixedWidth = (width) => ({
            ...singleLineEllipsisStyle,
            width,
            minWidth: width,
            maxWidth: width,
        });

        return [
            {
                field: 'transport.name',
                header: <span style={{display: 'block', ...singleLineEllipsisStyle}}>{t('user-transport.name')}</span>,
                frozen: true,
                alignFrozen: 'left',
                width: '170px',
                body: this.transportWithCarSharingTemplate.bind(this),
                bodyStyle: fixedWidth('170px'),
                headerStyle: fixedWidth('170px'),
            },
            {
                field: 'user.fullName',
                header: <span style={{display: 'block', ...singleLineEllipsisStyle}}>{t('user-transport.user')}</span>,
                frozen: true,
                alignFrozen: 'left',
                width: '260px',
                bodyStyle: fixedWidth('260px'),
                headerStyle: fixedWidth('260px'),
            },
            {field: 'avatar', header: t('user-transport.avatar'), body: this.avatarTemplate},
            {field: 'direction', header: t('user-transport.direction'), body: this.enumTemplate.bind(this, 'direction')},
            {
                field: 'startTravelDate',
                header: t('user-transport.startDate'),
                sortable: true,
                body: this.dateTimeTwoLineTemplate.bind(this, 'startTravelDate'),
            },
            {
                field: 'finishTravelDate',
                header: t('user-transport.endDate'),
                sortable: true,
                body: this.dateTimeTwoLineTemplate.bind(this, 'finishTravelDate'),
                
            },

            {
                field: 'burnedCalories',
                header: t('user-transport.calories'),
                float: 'right',
                body: this.formatValue,
            },
            {
                field: 'savedCo2Gram',
                header: (
                    <div>
                        {t('user-transport.saved')} CO<sub>2</sub>(g)
                    </div>
                ),
                float: 'right',
                body: this.formatValue,
            },
            {
                field: 'totalEarnedCoins',
                header: t('user-transport.points'),
                float: 'right',
                body: this.formatValue,
            },
            {
                field: 'totalDistanceTraveledKilometer',
                header: t('user-transport.traveled'),
                float: 'right',
                body: this.formatValue,
            },
            {
                field: 'percentageDeviation',
                header: t('user-transport.deviation'),
                float: 'right',
                color: 'red',
                body: this.percentageDeviationTemplate.bind(this),
            },
            {
                field: 'workRelated',
                header: t('user-transport.included'),
                float: 'right',
                body: this.formatWorkRelated.bind(this),
            },
            {
                field: 'successful',
                header: t('user-transport.successful'),
                float: 'right',
                body: this.formatBool.bind(this),
            },
            {field: '', float: 'center', header: t('global.action'), sortable: false, body: this.actionTemplate, width: '105px', frozen: true, alignFrozen: 'right'},
        ];
    }
    formatBool(rowData, obj) {
        return rowData[obj.field] ? t('global.yes') : t('global.no');
    }

    formatWorkRelated(rowData, obj) {
        return rowData[obj.field] ? (
            'tak'
        ) : rowData.userRequestedInclude ? (
            <label
                style={{
                    backgroundColor: 'orange',
                    width: '',
                    padding: '5px',
                    marginTop: '-10px',
                    marginBottom: '-10px',
                    borderRadius: '10px',
                }}
            >
                nie
            </label>
        ) : (
            'nie'
        );
    }

    percentageDeviationTemplate(rowData, obj) {
        let percentageDeviation = 0;
        if (StringUtils.isBlank(rowData[obj.field])) {
            percentageDeviation = 0;
        } else {
            percentageDeviation = rowData[obj.field];
        }
        if (percentageDeviation > -10) {
            return <label>{percentageDeviation}%</label>;
        }
        // TODO: why chip is not working......
        return (
            <div>
                {' '}
                <label
                    style={{
                        backgroundColor: '#FFCCCC',
                        width: '',
                        padding: '5px',
                        marginTop: '-10px',
                        marginBottom: '-10px',
                        borderRadius: '10px',
                    }}
                >
                    {percentageDeviation}%
                </label>{' '}
            </div>
        );
    }
    formatValue(rowData, obj) {
        if (StringUtils.isBlank(rowData[obj.field])) {
            return 0;
        }
        return rowData[obj.field];
    }

    transportWithCarSharingTemplate(rowData, obj) {
        const transportName = rowData?.transport?.name ?? '';
        const transportType = rowData?.transport?.type;
        const role = rowData?.carSharing?.role;
        const passengerCount = rowData?.carSharing?.passengerCount ?? 0;
        const isCarSharing = transportType === 'CARSHARING';

        if (!isCarSharing || StringUtils.isBlank(role)) {
            return transportName;
        }

        const isDriver = role === 'DRIVER';
        const roleIconClass = isDriver ? 'mdi mdi-steering' : 'mdi mdi-seat-passenger';
        const roleLabel = isDriver ? 'Kierowca' : 'Pasażer';
        const transportStyle = {whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'};

        return (
            <div style={{display: 'flex', alignItems: 'center', gap: '6px'}}>
                <span style={transportStyle}>{transportName}</span>
                <span title={roleLabel} style={{display: 'inline-flex', alignItems: 'center', color: '#666'}}>
                    <i className={roleIconClass} />
                </span>
                {isDriver ? <span style={{fontSize: '0.85em', color: '#666'}}>({passengerCount})</span> : null}
            </div>
        );
    }

    enumTemplate(field, rowData) {
        if (StringUtils.isBlank(rowData[field])) {
            return '';
        }
        return this.translate(`${field}.${rowData[field]}`);
    }
    actionTemplate(rowData) {
        const menuRef = React.createRef();
    
        const menuItems = [
           {
                label: t('global.details'),
                icon: 'pi pi-eye',
                command: () => {
                    const { detailUrl } = this.props;
                    const detailHref = `${detailUrl}/${rowData?.id}/` + sessionStorage.getItem('i18nextLng');
                    this.handleGoToDetail(detailHref);
                }
            },
            rowData.workRelated
                ? {
                      label: t('user-transport.exclude-transport'),
                      icon: 'pi pi-trash',
                      command: () => this.handleShowConfirmExcludeDialog(rowData.id)
                  }
                : {
                      label: t('user-transport.include-transport'),
                      icon: 'pi pi-plus-circle',
                      command: () => this.handleShowConfirmIncludeDialog(rowData)
                  },
            {
                label: t('user-transport.delete-transport'),
                icon: 'pi pi-times',
                command: () => this.handleShowConfirmDeleteDialog(rowData.id)
            }
        ];
    
        return (
            <div>
                    {rowData.workRelatedAlreadyExecutedToday && (
                        <span>
                            <Tooltip
                                id='tooltipWorkRelatedAlreadyExecutedToday'
                                position='left'
                                target='.workRelatedAlreadyExecutedToday'
                            />
                            <i
                                className='workRelatedAlreadyExecutedToday mdi mdi-alarm-light'
                                style={{fontSize: '20px', color: 'red'}}
                                data-pr-tooltip={`"${t('user-transport.repeated')}" "${t('DirectionType.' + rowData.direction)}"`}
                            ></i>
                        </span>
                    )}
                <Menu model={menuItems} popup ref={menuRef} />
                <Button
                    icon="pi pi-ellipsis-v"
                    className="menu-items"
                    onClick={(event) => menuRef.current.toggle(event)}
                />
                
            </div>
        );
    }
    
    handleShowConfirmExcludeDialog(id, e) {       
        this.setState({showConfirmExcludeTransport: true, elementId: id});
    }

    handleShowConfirmDeleteDialog(id) {
        this.setState({showConfirmDeleteTransport: true, elementId: id});
    }

    handleShowConfirmIncludeDialog(row, e) {       
        console.log(row);
        this.setState((prevState) => ({
            showConfirmIncludeTransport: true,
            elementId: row.id,
            element: {
                ...prevState.element,
                includeDirection: row.direction ?? null, 
            }
        }));
    }

    handleGoBack(e) {
        e.preventDefault();
        const {backUrl} = this.props;
        this.props.history.push(AppPrefixUtils.locationHrefUrl(backUrl));
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    renderDialog() {}

    breadCrumbItems() {
        return [{name: t('user-transport.listName'), url: '/transport-list'}];
    }
    onExcludeAction(callback) {
        this.blockUi();
        this.service
            .exclude(this.state.elementId)
            .then(() => {
                callback();
            })
            .catch((err) => {
                this.showErrorMessage(I18nUtils.getApiErrorMessage(err, t));
                this.setState({showConfirmExcludeTransport: false});
            });
    }
    onIncludeAction(callback) {
        this.blockUi();
        console.log(this.state.element.includeDirection);
        this.service
            .include(this.state.elementId, this.state.element.includeDirection)
            .then(() => {
                callback();
            })
            .catch((err) => {
                this.showErrorMessage(I18nUtils.getApiErrorMessage(err, t));
                this.setState({showConfirmIncludeTransport: false});
            });
    }

    onDeleteAction(callback) {
        this.blockUi();
        this.service
            .remove(this.state.elementId)
            .then(() => {
                callback();
            })
            .catch((err) => {
                this.showErrorMessage(I18nUtils.getApiErrorMessage(err, t));
                this.setState({showConfirmDeleteTransport: false});
                this.unblockUi();
            });
    }
    render() {
        return (
            <div className='container-fluid' >
                {this.state.showConfirmExcludeTransport ? (
                    <YesNoDialog
                        onChange={(type, x, target) => {
                            if (target.value) {
                                this.onExcludeAction(() => {
                                    this.setState({showConfirmExcludeTransport: false});
                                    this.showSuccessMessage(t('user-transport.exclude.success'));
                                    this.refreshTable();
                                    this.unblockUi();
                                });
                            } else {
                                this.setState({showConfirmExcludeTransport: false});
                            }
                        }}
                        visible={this.state.showConfirmExcludeTransport}
                        header={t('user-transport.exclude.header')}
                        name='visible'
                        noButtonLabel={t('global.noButtonLabel')}
                        yesButtonLabel={t('global.yesButtonLabel')}
                        onHide={() => {
                            this.setState({showConfirmExcludeTransport: false});
                        }}
                        yesButtonClassName='red-button'
                    >
                        {t('user-transport.exclude.message')}
                    </YesNoDialog>
                ) : null}

                {this.state.showConfirmDeleteTransport ? (
                    <YesNoDialog
                        onChange={(type, x, target) => {
                            if (target.value) {
                                this.onDeleteAction(() => {
                                    this.setState({showConfirmDeleteTransport: false});
                                    this.showSuccessMessage(t('user-transport.delete.success'));
                                    this.refreshTable();
                                    this.unblockUi();
                                });
                            } else {
                                this.setState({showConfirmDeleteTransport: false});
                            }
                        }}
                        visible={this.state.showConfirmDeleteTransport}
                        header={t('user-transport.delete.header')}
                        name='visible'
                        noButtonLabel={t('global.noButtonLabel')}
                        yesButtonLabel={t('global.yesButtonLabel')}
                        onHide={() => {
                            this.setState({showConfirmDeleteTransport: false});
                        }}
                        yesButtonClassName='red-button'
                    >
                        {t('user-transport.delete.message')}
                    </YesNoDialog>
                ) : null}

                {this.state.showConfirmIncludeTransport ? (
                    <YesNoDialog
                        onChange={(type, x, target) => {
                            if (target.value) {
                                this.onIncludeAction(() => {
                                    this.setState({showConfirmIncludeTransport: false});
                                    this.showSuccessMessage(t('user-transport.include.success'));
                                    this.refreshTable();
                                    this.unblockUi();
                                });
                            } else {
                                this.setState({showConfirmIncludeTransport: false});
                            }
                        }}
                        visible={this.state.showConfirmIncludeTransport}
                        header={t('user-transport.include.header')}
                        name='visible'
                        noButtonLabel={t('global.noButtonLabel')}
                        yesButtonLabel={t('global.yesButtonLabel')}
                        onHide={() => {
                            this.setState({showConfirmIncludeTransport: false});
                        }}
                        yesButtonClassName='red-button'
                    >
                          <div className="text-muted" style={{lineHeight: '1.4' }}>
                                                 <p className="mb-1">{t('user-transport.include.message')}</p>
                                                    <p className="mb-1">{t('user-transport.include.message2')}</p>
                                                </div>
                        <div className='mt-2'>
                                                  <div className='row col-12 align-items-center'>
                                                      <label className='col-auto text-muted'>{t('user-transport.includeDirection')}</label>
                                                      <div className='col'>
                                                          <InputDropdownComponent
                                                              showClear
                                                              id='includeDirection'
                                                              name='includeDirection'
                                                              optionLabel='label'
                                                              dataKey='value'
                                                              validator={this.validator}
                                                              validators='required'
                                                              value={this.state.element.includeDirection}
                                                              options={this.state.directionOptions}
                                                              colClass='col-xl-6 col-lg-6 col-md-6 col-sm-6'
                                                              onChange={this.handleChange}
                                                              viewMode={'EDIT'}
                                                              enumMode={true}
                                                          />
                                                      </div>
                                                  </div>
                                              </div>
                    </YesNoDialog>
                ) : null}
                <div id="user-transport-list-container" style={{width: '80vw !important'}}>
                {this.renderView()}
                </div>
            </div>
        );
    }

    dateTimeTwoLineTemplate(field, rowData) {
        if (rowData[field] && moment(rowData[field]).isValid()) {
            const date = moment(rowData[field]).format('YYYY-MM-DD');
            const time = moment(rowData[field]).format('HH:mm:ss');
            return (
                <div>
                    <div>{date}</div>
                    <div style={{fontSize: '0.9em', color: '#666'}}>{time}</div>
                </div>
            );
        } else {
            return '';
        }
    }
}

UserTransportListContainer.defaultProps = {
    detailUrl: '/user-transport/details',
    newUrl: '/user-transport/create',
    lazy: true,
};

UserTransportListContainer.propTypes = {
    detailUrl: PropTypes.string,
    newUrl: PropTypes.string,
};
export default withRouter(withTranslation()(UserTransportListContainer));
